import { combineReducers } from '@reduxjs/toolkit';
import { commonSlice } from "./common/slice";
import { fpsSlice } from "./features/fps/slice";
import { sberPaySlice } from "./features/sberpay/slice";
import { savedCardsSlice } from "./features/savedCards/slice";
import { bankCardsSlice } from "./features/bankCards/slice";
export var rootReducer = combineReducers({
  common: commonSlice.reducer,
  fps: fpsSlice.reducer,
  sberpay: sberPaySlice.reducer,
  savedCards: savedCardsSlice.reducer,
  bankCards: bankCardsSlice.reducer
});